import common from './common.json';
import home from './home.json';
import progress from './progress.json';
import settings from './settings.json';
import app from './app.json';
import workspace from './workspace.json';
import download from './download.json';
import compression from './compression.json';
import editor from './editor.json';
import ui from './ui.json';
import endToEnd from './endToEnd.json';
import modals from './modals.json';
import services from './services.json';

export default {
  common,
  home,
  progress,
  settings,
  app,
  workspace,
  download,
  compression,
  editor,
  ui,
  endToEnd,
  modals,
  services,
};
